/** Stable ids in parent_reviews.responses JSON (fishsix_v1). */

export const FISHSIX_SURVEY_VERSION = "fishsix_v1";

export interface FishSurveyOption {
  id: string;
  label: string;
}

/** 1.2 / 1.3 — พัฒนาการและทัศนคติทางการเรียน */
export const FISHSIX_SURVEY_LEARNING_OPTIONS: FishSurveyOption[] = [
  { id: "content_understanding", label: "ความเข้าใจเนื้อหา: เข้าใจนิยามหรือหลักการพื้นฐานของวิชาที่เรียนได้ดีขึ้น" },
  { id: "problem_solving_skills", label: "ทักษะการแก้โจทย์: สามารถทำโจทย์ที่ซับซ้อน หรือโจทย์ประยุกต์ได้ด้วยตัวเอง" },
  { id: "grades", label: "ผลคะแนน/เกรด: มีคะแนนสอบหรือเกรดที่โรงเรียนพัฒนาขึ้น" },
  { id: "confidence", label: "ความมั่นใจ: กล้าตอบคำถาม ไม่กลัวที่จะทำผิด มีทัศนคติบวกต่อวิชาที่เคยยาก" },
  { id: "motivation", label: "แรงจูงใจในการเรียน: มีความกระตือรือร้น อยากมาเรียน หรือเข้าเรียนตรงเวลา" },
  { id: "focus", label: "สมาธิและการจดจ่อ: สามารถโฟกัสกับการทำโจทย์หรือการเรียนได้นานขึ้น" },
  { id: "systematic_thinking", label: "การคิดเป็นระบบ: มีการคิดวิเคราะห์ที่เป็นเหตุเป็นผล" },
  { id: "self_directed_learning", label: "การเรียนรู้ด้วยตนเอง: เริ่มรู้จักการวางแผนทบทวน หรือทำแบบฝึกหัดเองโดยไม่ต้องบังคับ" },
];

/** 2.2 / 2.3 — คุณครูและการสอนแบบ Personalize */
export const FISHSIX_SURVEY_TEACHER_OPTIONS: FishSurveyOption[] = [
  { id: "personalize", label: "การสอนที่ตรงจุด (Personalize): ครูปรับเนื้อหาและวิธีสอนได้เหมาะกับพื้นฐานของน้อง" },
  { id: "explanation", label: "การอธิบาย: ครูอธิบายเรื่องยากให้เข้าใจง่าย มีเทคนิคการสอนที่น่าสนใจ" },
  { id: "encouragement", label: "การสร้างกำลังใจ: ครูใช้จิตวิทยาเชิงบวก ชมเชยและสร้างความเชื่อมั่นให้เด็ก" },
  { id: "professionalism", label: "ความเป็นมืออาชีพ: ครูมีความเชี่ยวชาญในเนื้อหาวิชาที่สอนอย่างแม่นยำ" },
  { id: "varied_media", label: "การใช้สื่อการสอนที่หลากหลาย: การนำสื่อประเภทอื่น ๆ มาใช้กระตุ้นการเรียนรู้ได้อย่างเหมาะสม" },
  { id: "listening", label: "การรับฟัง: ครูเปิดโอกาสให้น้องซักถาม และให้ความสำคัญกับเป้าหมายของนักเรียน" },
  { id: "report_detail", label: "ความละเอียดของรายงาน: การให้ Feedback หรือแจ้งจุดเด่น/จุดที่ต้องพัฒนาของน้องให้ผู้ปกครองทราบ" },
];

/** 3.2 / 3.3 — การบริการและการจัดการ */
export const FISHSIX_SURVEY_ADMIN_OPTIONS: FishSurveyOption[] = [
  { id: "speed", label: "ความรวดเร็ว: การติดต่อสอบถามผ่าน Line หรือโทรศัพท์" },
  { id: "flexibility", label: "ความยืดหยุ่น: การจัดการเรื่องวัน-เวลาเรียน หรือการขอเลื่อนคลาส" },
  { id: "hours_system", label: "ระบบตรวจสอบชั่วโมง: ความง่ายในการเช็กจำนวนชั่วโมงที่เหลือหรือการจองคลาส" },
  { id: "data_accuracy", label: "ความถูกต้องของข้อมูล: ตารางเรียน วิชาที่เรียน และการประสานงานของแอดมิน" },
  { id: "consistency", label: "ความสม่ำเสมอ: การแจ้งเตือนก่อนเข้าเรียน หรืออัปเดตข่าวสารของสถาบัน" },
];

/** 4.2 / 4.3 — สถานที่และสภาพแวดล้อม */
export const FISHSIX_SURVEY_FACILITY_OPTIONS: FishSurveyOption[] = [
  { id: "learning_atmosphere", label: "บรรยากาศการเรียน: เงียบสงบ เอื้อต่อการใช้สมาธิ ไม่วุ่นวาย" },
  { id: "cleanliness", label: "ความสะอาด: พื้นที่ภายในสาขา โต๊ะเรียน และห้องน้ำ" },
  { id: "equipment", label: "อุปกรณ์สนับสนุน: เอกสารประกอบการเรียน คอมพิวเตอร์ หรือสื่อดิจิทัลต่างๆ" },
  { id: "online_system", label: "ระบบออนไลน์: ความเสถียรของสัญญาณ ลิงก์ Zoom หรือแอปพลิเคชันที่ใช้เรียน" },
  { id: "reception_area", label: "พื้นที่รับรอง: ความเพียงพอของที่นั่งพักคอยสำหรับนักเรียนหรือผู้ปกครอง" },
  { id: "safety", label: "ความปลอดภัย: มาตรฐานการดูแลเด็กภายในสาขา" },
  { id: "parking", label: "ที่จอดรถ: ความเพียงพอของพื้นที่จอดรถสำหรับรับ-ส่ง" },
  { id: "traffic", label: "การจราจร: ความสะดวกในการเข้า-ออกสาขา หรือจุดรับ-ส่งน้อง" },
];

export interface FishsixSurveyResponsesV1 {
  version: typeof FISHSIX_SURVEY_VERSION;
  s1_academic_development: number;
  s1_clear_outcomes: string[];
  s1_emphasize_more: string[];
  s2_teacher_quality: number;
  s2_teacher_strengths: string[];
  s2_teacher_improve: string[];
  s3_admin_service: number;
  s3_admin_strengths: string[];
  s3_admin_improve: string[];
  s4_facility_atmosphere: number;
  s4_facility_strengths: string[];
  s4_facility_improve: string[];
  s5_additional: string;
}

/** Labels for admin readout (Thai prompts match the survey). */
export const FISHSIX_SURVEY_SECTION_DISPLAY = {
  s1: {
    kicker: "ส่วนที่ 1",
    title: "พัฒนาการและทัศนคติทางการเรียน",
    academic: "1.1 คะแนนความพึงพอใจต่อ พัฒนาการทางการเรียน ของน้อง",
    clearOutcomes: "1.2 ผลลัพธ์ที่เห็นผลชัดเจน",
    emphasizeMore: "1.3 สิ่งที่อยากให้เน้นเพิ่ม",
  },
  s2: {
    kicker: "ส่วนที่ 2",
    title: "คุณภาพคุณครูและการสอนแบบ Personalize",
    teacherQuality: "2.1 คะแนนความพึงพอใจต่อ คุณภาพของคุณครูผู้สอน",
    strengths: "2.2 จุดแข็งของคุณครู",
    improve: "2.3 สิ่งที่อยากให้ปรับปรุง",
  },
  s3: {
    kicker: "ส่วนที่ 3",
    title: "การบริการและการจัดการ",
    adminService: "3.1 คะแนนความพึงพอใจต่อ การบริการและการประสานงาน",
    strengths: "3.2 จุดแข็งของการบริการ",
    improve: "3.3 สิ่งที่อยากให้ปรับปรุง",
  },
  s4: {
    kicker: "ส่วนที่ 4",
    title: "สถานที่และสภาพแวดล้อม",
    facilityAtmosphere: "4.1 คะแนนความพึงพอใจต่อ บรรยากาศและสิ่งอำนวยความสะดวก",
    strengths: "4.2 จุดแข็งของสถานที่",
    improve: "4.3 สิ่งที่อยากให้ปรับปรุง",
  },
  s5: {
    kicker: "ส่วนที่ 5",
    title: "ความคิดเห็นเพิ่มเติม",
    prompt: "ข้อความเพิ่มเติม",
  },
} as const;
